import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Services from "./pages/Services";
import Industries from "./pages/Industries";
import Blog from "./pages/Blog";
import About from "./pages/About";
import Contact from "./pages/Contact";

import ApplicationDevelopment from "./pages/ApplicationDevelopment";
import AIDataOperations from "./pages/AIDataOperations";
import StaffingService from "./pages/StaffingService";
import DigitalMarketing from "./pages/DigitalMarketing";
import RCMServices from "./pages/RCMServices";
import TalentContinuityManagement from "./pages/TalentContinuityManagement";

import Disclaimer from "./pages/Disclaimer";
import Privacy from "./pages/Privacy";
import FAQs from "./pages/FAQs";
import Terms from "./pages/Terms";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-background">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />

            <Route path="/services" element={<Services />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />

            <Route path="/ApplicationDevelopment" element={<ApplicationDevelopment />} />
            <Route path="/AIDataOperations" element={<AIDataOperations />} />
            <Route path="/StaffingService" element={<StaffingService />} />
            <Route path="/DigitalMarketing" element={<DigitalMarketing />} />
            <Route path="/RCMServices" element={<RCMServices />} />
            <Route path="/TalentContinuityManagement" element={<TalentContinuityManagement />} />
            
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
